module.exports = __webpack_public_path__ + "static/media/galerija_2019 (33).537b779d.jpg";